<template>
  <div
    v-if="microphonePermission && microphonePermission !== Permissions.GRANTED"
    id="microphone-permission" >
    <!-- Shown when asking for permission. -->
    <div
      v-if="microphonePermission === Permissions.PROMPT"
      class="permission-message flex column center-all">
      <SBIcon
        :icon="SBIconList.WHATSAPP_LOGO"
        :color="SBColors.white"
        :size="50" />
      <h1>Allow microphone</h1>
      <span>To record voice messages, click "Allow" to give AI Number access to your microphone.</span>
      <b-button
        variant="primary"
        @click="close">Done</b-button>
    </div>
    <!-- Shown when permission is denied. -->
    <div
      v-if="microphonePermission === Permissions.DENIED"
      class="permission-message flex column center-all">
      <SBIcon
        :icon="SBIconList.WHATSAPP_LOGO"
        :color="SBColors.white"
        :size="50" />
      <h1>Allow microphone</h1>
      <span>To record Voice Messages, AI Number needs access to your microphone. Click in the URL bar and choose “Always allow web.whatsapp.com to access your microphone.”</span>
      <b-button
        variant="primary"
        @click="close">Done</b-button>
    </div>
  </div>
</template>

<script>
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import Permissions from '@/helpers/lists/browserPermissions';

export default {
  name: 'MicrophonePermission',
  components: {
    SBIcon,
  },
  data() {
    return {
      microphonePermission: null,
      SBIconList,
      SBColors,
      Permissions,
    };
  },
  mounted() {
    this.$eventBus.$on('microphone-status', this.microphoneStatusChange);
  },
  beforeDestroy() {
    this.$eventBus.$off('microphone-status', this.microphoneStatusChange);
  },
  methods: {
    close() {
      this.microphonePermission = null;
    },
    microphoneStatusChange(microphonePermission) {
      this.microphonePermission = microphonePermission;
    },
  },
};
</script>

<style lang="scss" scoped>
#microphone-permission {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba($blackPrimary, 0.9);
  z-index: 99999;
  color: $white;

  .permission-message {
    height: 100%;

    h1 {
      font-size: 24px;
      font-weight: 500;
      margin: 25px 0 15px;
    }

    span {
      max-width: 350px;
      text-align: center;
      font-size: 14px;
      margin-bottom: 45px;
    }
  }
}
</style>
